import {autoserializeAs, autoserializeAsArray} from "dcerialize";
import {TimelineEvent} from "./TimelineEvent";
import type {IPaginated} from "../IPaginated";

export class Timeline implements IPaginated<TimelineEvent> {
  @autoserializeAsArray(() => TimelineEvent)
  public readonly entries: readonly TimelineEvent[];
  @autoserializeAs(() => Number)
  public readonly total: number;
}
